// material-ui
import { useTheme } from '@mui/material/styles';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //
// "https://assets.travclan.com/unsafe/200x0/smart/http://flights-uat.travclan.com/travclan_logo_latest.png"

const Logo = () => {
    const theme = useTheme();
    const themePaletteMode = theme.palette.mode;
    return (
        <img
            src={
                themePaletteMode === 'light'
                    ? '/logo.png'
                    : 'https://assets.travclan.com/unsafe/200x0/smart/http://flights-uat.travclan.com/travclan_logo_latest.png'
            }
            alt="logo"
            style={{ width: '100px' }}
        />
    );
};

export default Logo;
